module.exports = __webpack_public_path__ + "static/ballcamera.5d7424c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/ballcamera.jpg
// module id = 114
// module chunks = 126093192170660 213534597649335